import { useEffect, useState } from 'react';

// Redux & Action
import { useSelector, useDispatch } from 'react-redux';
import { setOpenWheelStatus } from "../../../../../../@core/redux/actions/app/wheel";

// Icon
import CloseOutlined from '@material-ui/icons/CloseOutlined';

const FabWheelSpinIcon = () => {
    const reduxAppCMS = useSelector(state => state.reduxAppCMS.cms);
    const [dataIconWheenSpin, setDataIconWheelSpin] = useState(null);
    const [showIcon, setShowIcon] = useState(true);
    const dispatch = useDispatch();

    const closeEvent = () => {
        setShowIcon(false);
    };

    const clickEvent = () => {
        dispatch(setOpenWheelStatus(true));
    };

    useEffect(() => {
        if (reduxAppCMS && !dataIconWheenSpin) {
            if (reduxAppCMS["section-icon-home-wheel-spin"]) {
                setDataIconWheelSpin(reduxAppCMS["section-icon-home-wheel-spin"]);
            }
        }
    }, [reduxAppCMS, dataIconWheenSpin]);

    return (dataIconWheenSpin && showIcon) && (
        <div className="iconWheeSpinHomePosition">
            <div className="iconWheeSpinHomeContent">
                <img className="iconWheeSpinHomeImg" src={dataIconWheenSpin} onClick={clickEvent} />

                <div className="iconWheeSpinHomeClose">
                    <CloseOutlined className="iconWheeSpinHomeCloseSize" onClick={closeEvent} />
                </div>
            </div>
        </div>
    );
}

export default FabWheelSpinIcon;